import { useEffect, useRef } from "react";

// Sets up an IntersectionObserver-driven reveal effect for elements with `.reveal`.
export default function useReveal() {
    const rootRef = useRef(null);

    useEffect(() => {
        const root = rootRef.current || document;
        const els = root.querySelectorAll(".reveal");
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return rootRef;
}
